import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "company-information-form-advice typographies-paragraph-small-semibold" }

import { inject } from 'vue';
import { Translator } from 'types/injects/translator.type';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyInformationFormAdvice',
  setup(__props) {

const $t = inject('$t') as Translator;

return (_ctx: any,_cache: any) => {
  const _component_CompassIcon = _resolveComponent("CompassIcon")!

  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createVNode(_component_CompassIcon, {
      icon: "comment-fill",
      size: _ctx.CompassEnums.IconSize.SMALL
    }, null, 8 /* PROPS */, ["size"]),
    _createTextVNode(" " + _toDisplayString(_unref($t).__('CompanyInformation.form.advice')), 1 /* TEXT */)
  ]))
}
}

})